import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
// ─ ordre critique : Tailwind d'abord, puis Leaflet (Leaflet override les resets) ─
import "@/index.css";
import "leaflet/dist/leaflet.css"; // V3-T1 : import global, garantit le chargement
                                   // avant tout rendu React (pas de lazy-split CSS)
import App from "@/App";
import { Capacitor } from "@capacitor/core";
import { initNative } from "@/lib/native";
import { installeRechargementImagesSignees } from "@/lib/imagesSignees";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);

// Intégrations natives (status bar, splash, bouton retour Android) — no-op web.
initNative();

// Étape 4 (21/09) : les <img> chargent des URLs signées expirantes. Un onglet
// resté ouvert au-delà de la validité redemande une signature fraîche et
// recharge l'image tout seul (une tentative, comptes connectés uniquement).
installeRechargementImagesSignees();

// PWA : service worker uniquement sur le web. Dans la coquille native, le SW
// entrerait en conflit avec le cache applicatif de Capacitor.
if (!Capacitor.isNativePlatform() && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
